module.exports = __webpack_public_path__ + "media/Images/icon-rocket-blue-0d6911385a616de344e280ac472be5f9.svg";